import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=1628c5a3"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=1628c5a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports